<template>
    <!--<Submenu :name="`${parentItem.name}`">
        <template slot="title">
            <common-icon :type="parentItem.meta.icon || ''"/>
            <span>{{ parentItem.meta.title }}</span>
        </template>
        <template v-if="parentItem.children && parentItem.children.length>=1">
            <template v-for="item in parentItem.children">
                <side-menu-item v-if="item.children && item.children.length>=1" :key="`menu-${item.name}`"
                                :parent-item="item"></side-menu-item>
                <menu-item v-else :name="item.name" :key="`menu-${item.name}`">
                    <common-icon :type="item.meta.icon || ''"/>
                    <span>{{ item.meta.title }}</span></menu-item>
            </template>
        </template>
    </Submenu>-->
    <Submenu :name="`${parentItem.name}`">
        <template slot="title">
            <common-icon :type="parentItem.icon || ''"/>
            <span>{{ parentItem.title }}</span>
        </template>
        <template v-if="parentItem.children && parentItem.children.length>=1">
            <template v-for="item in parentItem.children">
                <side-menu-item v-if="item.children && item.children.length>=1" :key="`menu-${item.name}`"
                                :parent-item="item"></side-menu-item>
                <menu-item v-else :name="item.name" :key="`menu-${item.name}`">
                    <common-icon :type="item.icon || ''"/>
                    <span>{{ item.title }}</span></menu-item>
            </template>
        </template>
    </Submenu>
</template>
<script>
    import mixin from './mixin'

    export default {
        name: 'SideMenuItem',
        mixins: [mixin],
        props: {
            parentItem: {
                type: Object,
                default: () => {
                }
            }
        },
    }
</script>
